import * as PIXI from "pixi.js"
import { PointProperty } from "./Model/types"
import Settings from "./Settings"

export default class DetailItem extends PIXI.Container {
    sideMargin = 10

    constructor(property: PointProperty, width = 300, height = 40) {
        super()

        const bg = new PIXI.Graphics()
        bg.beginFill(0xffffff)
        bg.lineStyle(1, 0xbcc3c9, 0.5)
        bg.drawRoundedRect(0, 0, width, height, 8)
        bg.endFill()
        this.addChild(bg)

        const style = new PIXI.TextStyle({
            fontFamily: "Courier",
            fontSize: 16,
            fill: "#2F3A45",
        })
        const titleText = new PIXI.Text(property.name, style)
        titleText.resolution = 2

        // titleText.anchor.set(0, 0.5)
        titleText.x = this.sideMargin
        titleText.y = height / 2 - titleText.height / 2
        this.addChild(titleText)

        const style2 = new PIXI.TextStyle({
            fontFamily: "Courier Prime",
            fontWeight: "bold",
            fontSize: 18,
            fill: "#2F3A45",
        })
        const valueText = new PIXI.Text(property.value, style2)
        valueText.resolution = 2

        // valueText.anchor.set(1, 0)
        valueText.x = width - 17 - valueText.width
        valueText.y = height / 2 - valueText.height / 2
        this.addChild(valueText)

        const pill = new PIXI.Graphics()
        if (property.hasWarning) {
            pill.beginFill(Settings.colorWarning)
        } else {
            pill.beginFill(Settings.colorNominal)
        }

        pill.drawRoundedRect(valueText.x - 10, 7, valueText.width + 20, height - 14, 4)
        pill.endFill()
        bg.addChild(pill)
    }
}
